import { configureStore } from '@reduxjs/toolkit'
import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';
import useReducer from './Modules/User'

const Store = configureStore({
  reducer: {
    user: useReducer
  }
})

// The types of dispatch and state are defined globally and exported.
export type RootState = ReturnType<typeof Store.getState>;
export type AppDispatch = typeof Store.dispatch;

// effect: don't need to redefine the TS type every time you use useSelector and useDispatch
// export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppDispatch = () =>  useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default Store